import React, { FunctionComponent, useRef, useState } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { UserProfile } from 'fitbeat.models';
import { ScrollView } from 'react-native';
import { nutritionDashTileSelected } from '../actions';
import { DashboardSection } from './DashboardSection';
import { HorizontalScroller } from './HorizontalScroller';
import { MealCard } from './MealCard';

interface IProps {
  nutritionError: string;
  nutritionData: any;
  t: (key: string) => string;
  navigation: any;
  isLoading: boolean;
  startBookingFromDashboard: () => void;
  user: any;
  userProfile: UserProfile;
}

const NutritionDashTile: FunctionComponent<IProps> = ({
  nutritionData,
  t,
  navigation,
  isLoading,
  user,
  userProfile,
}) => {
  const scrollViewRef = useRef<ScrollView>(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <DashboardSection
      heading={t('nextMeals')}
      isLoading={isLoading}
    >
      <HorizontalScroller 
        ref={scrollViewRef}
        currentIndex={currentIndex}
        onIndexChange={setCurrentIndex}
        totalItems={nutritionData?.length ?? 0}
      >
        {!nutritionData && (
          <MealCard
            t={t}
            nutritionData={nutritionData}
            navigation={navigation}
            user={user}
            navigateDashboardOnPress
          />
        )}
        {nutritionData && nutritionData.map((meal, index) => (
          <MealCard
            t={t}
            nutritionData={meal}
            key={index}
            navigation={navigation}
            lastCard={index === nutritionData.length - 1}
            user={user}
            userProfile={userProfile}
          />
        ))}
      </HorizontalScroller>
    </DashboardSection>
  );
};

export default translate(['dashboard'])(connect(null, { nutritionDashTileSelected })(NutritionDashTile));
